import { Expose, Type } from "class-transformer";

import { PgaPolicy } from "src/shared/models/pga-policy.model";
import { Vehicle } from "src/shared/models/vehicle.model";

export class SoatPolicy extends PgaPolicy {
    @Expose()
    @Type(() => Vehicle)
    vehicle?: Vehicle;
}
